import React from 'react';
export function ProtocolPhases() {
  const phases = [{
    num: '1',
    title: 'El Interruptor de Cortisol'
  }, {
    num: '2',
    title: 'Caminata Bio-Mecánica (El secreto del elevador)'
  }, {
    num: '3',
    title: 'Socialización Urbana (Modo Restaurante)'
  }, {
    num: '4',
    title: 'Control el Pasillo y la Puerta'
  }];
  return <section className="py-10 px-4 bg-cloud-grey" data-id="element-247">
      <div className="max-w-5xl mx-auto" data-id="element-248">
        <div className="text-center mb-8" data-id="element-249">
          <h2 className="text-3xl md:text-4xl font-bold font-serif text-gray-900 mb-4" data-id="element-250">
            El Protocolo de 4 Fases
          </h2>
          <p className="text-gray-600 text-lg" data-id="element-251">
            Un sistema paso a paso diseñado para la mente canina.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-252">
          {phases.map((phase, idx) => <div key={idx} className="bg-white border-2 border-gray-900 rounded-[20px] p-6 flex items-center shadow-sm hover:shadow-md transition-shadow" data-id="element-253">
              <div className="w-12 h-12 flex-shrink-0 bg-brand-gold-light rounded-full flex items-center justify-center border border-brand-gold mr-4" data-id="element-254">
                <span className="text-brand-gold font-bold text-2xl" data-id="element-255">
                  {phase.num}
                </span>
              </div>
              <h3 className="text-lg sm:text-xl font-bold text-gray-900" data-id="element-256">
                {phase.title}
              </h3>
            </div>)}
        </div>
      </div>
    </section>;
}